<template>
  <Modal v-model="show" :title="'报价信息编辑'" :mask-closable="false" :closable='false' width="700">
    <Form :model="form" ref="form" :rules="rules" :label-width="120" inline>
      <FormItem label="报价模板" prop="quotationTtemplate">
        <RadioGroup v-model="form.quotationTtemplate" style="width: 400px">
          <Radio :label="item.value" v-for="(item,index) in quotationTtemplateData" :key="index"><span>{{item.name}}</span></Radio>
        </RadioGroup>
      </FormItem>
      <Row>
        <Col span="8">
        <FormItem label="模板上传" prop="模板_Files">
          <Upload ref="upload" multiple type="drag" :show-upload-list="false" style="width: 90px" :accept="accept" :default-file-list="form.模板_Files" :on-remove="handleRemove" :data="uploadDataFH" :format='format'
            :on-success="handleSuccess" :on-format-error="handleFormatError" :on-preview="handlePreview" :action="$constDefinition.baseUrl+'/File/UploadByCustomer'">
            <div style="padding: 10px 0">
              <Icon type="ios-cloud-upload" size="22" style="color: #3399ff"></Icon>
              <p>上传文件</p>
            </div>
          </Upload>
        </FormItem>
        </Col>
        <Col span="14">
        <!-- 文件列表 -->
        <div class="fileList" v-if="form.模板_Files.length>0">
          <!-- <Divider plain orientation="left">已上传模板</Divider> -->
          <template v-for="(img, img_i) in form.模板_Files">
            <span :key="img_i" class="img_wrap">
              <span class="pos">
                <img class="img" :src="$constDefinition.baseUrl+ img.url" width="85px" height="85px" />
                <i class="img_magnify">
                  <Icon size="26" class="ico" color="#ffffff" v-if="!isDisable" @click="handleRemove(img_i,img.fileGuids)" type="ios-trash-outline" />
                  <Icon size="26" class="ico" color="#ffffff" @click="handleDownload(img.fileGuids,img.fileName,'报价模板')" type="md-arrow-down" />
                </i>
              </span>
              <span class="filename" :title="img.fileName">{{img.fileName}}</span>
            </span>
          </template>
        </div>
        </Col>
      </Row>
      <FormItem label="联系人:" prop="contactsIdList">
        <Select v-model="form.contactsIdList" multiple style="width:465px">
          <Option v-for="item in contactsData" :value="item.value" :key="item.value">{{ item.name }}</Option>
        </Select>
      </FormItem>
      <FormItem label="报价类型:" prop="quotationTypeList">
        <CheckboxGroup v-model="form.quotationTypeList" style="width:465px">
          <Checkbox :label="item.value" border v-for="item in quotationTypeData" style="margin-bottom: 5px">{{item.name}}</Checkbox>
        </CheckboxGroup>
      </FormItem>
      <FormItem label="其他报价类型:" v-if="form.quotationTypeList && form.quotationTypeList.indexOf(6) > -1">
        <Input v-model="form.otherQuotationType" type="textarea" :maxlength="200" placeholder="请输入" style="width: 465px"></Input>
      </FormItem>
	  
      <FormItem label="投标流程:" prop="biddingProcess">
        <Input v-model="form.biddingProcess" type="textarea" :maxlength="200" placeholder="请输入" style="width: 465px"></Input>
      </FormItem>
	  <Row>
	    <Col span="8">
	    <FormItem label="投标流程附件:" prop="投标流程_Files">
	      <Upload ref="upload" multiple type="drag" :show-upload-list="false" style="width: 90px" :accept="accept" :default-file-list="form.投标流程_Files" :on-remove="handleRemoveTBLC" :data="uploadDataTBLC" :format='format'
	        :on-success="handleSuccessTBLC" :on-format-error="handleFormatErrorTBLC" :on-preview="handlePreview" :action="$constDefinition.baseUrl+'/File/UploadByCustomer'">
	        <div style="padding: 10px 0">
	          <Icon type="ios-cloud-upload" size="22" style="color: #3399ff"></Icon>
	          <p>上传文件</p>
	        </div>
	      </Upload>
	    </FormItem>
	    </Col>
	    <Col span="14">
	    <!-- 文件列表 -->
	    <div class="fileList" v-if="form.投标流程_Files.length>0">
	      <!-- <Divider plain orientation="left">已上传模板</Divider> -->
	      <template v-for="(img, img_i) in form.投标流程_Files">
	        <span :key="img_i" class="img_wrap">
	          <span class="pos">
	            <img class="img" :src="$constDefinition.baseUrl+ img.url" width="85px" height="85px" />
	            <i class="img_magnify">
	              <Icon size="26" class="ico" color="#ffffff" v-if="!isDisable" @click="handleRemoveTBLC(img_i,img.fileGuids)" type="ios-trash-outline" />
	              <Icon size="26" class="ico" color="#ffffff" @click="handleDownload(img.fileGuids,img.fileName,'投标流程')" type="md-arrow-down" />
	            </i>
	          </span>
	          <span class="filename" :title="img.fileName">{{img.fileName}}</span>
	        </span>
	      </template>
	    </div>
	    </Col>
	  </Row>
      <FormItem label="标书范文:" prop="bidTemplate">
        <Input v-model="form.bidTemplate" type="textarea" placeholder="请输入" style="width: 465px"></Input>
      </FormItem>
	  <Row>
	    <Col span="8">
	    <FormItem label="标书范文附件:" prop="标书范文_Files">
	      <Upload ref="upload" multiple type="drag" :show-upload-list="false" style="width: 90px" :accept="accept" :default-file-list="form.标书范文_Files" :on-remove="handleRemoveBSFW" :data="uploadDataBSFW" :format='format'
	        :on-success="handleSuccessBSFW" :on-format-error="handleFormatErrorBSFW" :on-preview="handlePreview" :action="$constDefinition.baseUrl+'/File/UploadByCustomer'">
	        <div style="padding: 10px 0">
	          <Icon type="ios-cloud-upload" size="22" style="color: #3399ff"></Icon>
	          <p>上传文件</p>
	        </div>
	      </Upload>
	    </FormItem>
	    </Col>
	    <Col span="14">
	    <!-- 文件列表 -->
	    <div class="fileList" v-if="form.标书范文_Files.length>0">
	      <!-- <Divider plain orientation="left">已上传模板</Divider> -->
	      <template v-for="(img, img_i) in form.标书范文_Files">
	        <span :key="img_i" class="img_wrap">
	          <span class="pos">
	            <img class="img" :src="$constDefinition.baseUrl+ img.url" width="85px" height="85px" />
	            <i class="img_magnify">
	              <Icon size="26" class="ico" color="#ffffff" v-if="!isDisable" @click="handleRemoveBSFW(img_i,img.fileGuids)" type="ios-trash-outline" />
	              <Icon size="26" class="ico" color="#ffffff" @click="handleDownload(img.fileGuids,img.fileName,'标书范文')" type="md-arrow-down" />
	            </i>
	          </span>
	          <span class="filename" :title="img.fileName">{{img.fileName}}</span>
	        </span>
	      </template>
	    </div>
	    </Col>
	  </Row>
    </Form>
    <Spin size="large" fix v-show="spinShow"></Spin>
    <div slot="footer">
      <Button @click="close()" class="close-btn">关闭</Button>
      <Button @click="submit()" type="primary" :disabled="spinShow" class="close-btn" v-if="!isDisable">提交</Button>
    </div>
  </Modal>
</template>
<script>
export default {
  name: 'CreateProduct',
  props: {
    show: Boolean, //弹窗 窗口显示
    customerId: Number,
    quotationId: Number,
	isDetail:Boolean
  },
  data() {
    return {
      accept: '.doc,.jpg,.jpeg,.png,.gif,.JPG,.JPEG,.GIF,.PNG,.EXCEL,.WORD,.PDF,.excel,.excl,.xlsx,.xls,.word,.docx,.pdf',
      format: ['doc','docx','xlsx','xls','jpg', 'pdf', 'png', 'jpeg'],
      form: {
        quotationTtemplate: null,
        模板_Files: [],
        投标流程_Files: [],
        标书范文_Files: [],
        quotationTypeList: [],
		otherQuotationType:'',
        contactsIdList: [],
        biddingProcess: '',
        bidTemplate: '',
        templateGuids: '',
        customerId: this.customerId,
        id: this.quotationId,
      },
      rules: {
        quotationTtemplate: [
          { required: true, message: '请选择', trigger: 'blur,change', type: 'number' },
        ],
        contactsIdList: [
          { required: true, message: '请选择', trigger: 'blur,change', type: 'array' },
        ],
        quotationTypeList: [
          { required: true, message: '请选择', trigger: 'blur,change', type: 'array' },
        ],
        biddingProcess: [
          { required: false, message: '请输入', trigger: 'blur,change', type: 'string' },
        ],
        bidTemplate: [
          { required: false, message: '请输入', trigger: 'blur,change', type: 'string' },
        ],
        模板_Files: [
          { required: true, message: '请上传文件', trigger: 'blur,change', type: 'array' },
        ],
      },
      uploadDataFH: {
        id: this.customerId,
        type: this.$constDefinition['报价信息_报价模板'],
      },
	  uploadDataTBLC: {
	    id: this.customerId,
	    type: this.$constDefinition['报价信息_投标流程'],
	  },
	  uploadDataBSFW: {
	    id: this.customerId,
	    type: this.$constDefinition['报价信息_标书范文'],
	  },
      quotationTypeData: [], //
      quotationTtemplateData: [], //
	  isDisable:false,
      contactsData: [], //list
      spinShow: false,
    }
  },
  mounted() {
    console.log(this.customerId)
    if (this.customerId) {
      this.spinShow = true
      this.getUser()
    }
    if (this.quotationId) {
      this.getDetail()
    }
	if(this.isDetail){
		this.isDisable=this.isDetail
		}
  },
  methods: {
    // 关闭弹窗
    close(refresh) {
      this.form = {
        quotationTtemplate: null,
        模板_Files: [],
        投标流程_Files: [],
        标书范文_Files: [],
        quotationTypeList: [],
		otherQuotationType:'',
        contactsIdList: [],
        biddingProcess: '',
        bidTemplate: '',
        templateGuids: '',
        customerId: this.customerId,
        id: 0,
      }
      this.$refs['form'].resetFields()
      this.$emit('close', refresh)
    },
    //   提交记录
    submit() {
      let _this = this
      console.log('🚀 ~ file: createProduct.vue:83 ~ submit ~ this.form:', this.form)
      this.$refs['form'].validate(async (valid) => {
        if (valid) {
          let files = []
          let files2 = []
          let files3 = []

          if (_this.form.模板_Files.length > 0) {
            _this.form.模板_Files.map((file) => {
              files.push(file.fileGuids)
            })
            _this.form.templateGuidList = files
          }
		  if (_this.form.投标流程_Files.length > 0) {
		    _this.form.投标流程_Files.map((file) => {
		      files2.push(file.fileGuids)
		    })
		    _this.form.biddingProcessGuidList = files2
		  }
		  if (_this.form.标书范文_Files.length > 0) {
		    _this.form.标书范文_Files.map((file) => {
		      files3.push(file.fileGuids)
		    })
		    _this.form.bidTemplateGuidList = files3
		  }
          this.spinShow = true
          var url = ''
          if (this.form.id != null && this.form.id != 0) {
            url = '/api/services/app/CustomerQuotationApiService/Update'
            let { data } = await this.$Ajax.put(url, _this.form)
            if (data.success) {
              this.$Message.success({
                content: '编辑成功',
              })
              _this.close(true)
            }
          } else {
            url = '/api/services/app/CustomerQuotationApiService/Create'
            let { data } = await this.$Ajax.post(url, _this.form)
            if (data.success) {
              this.$Message.success({
                content: '新建成功',
              })
              _this.close(true)
            }
          }
          this.spinShow = false
        }
      })
    },
    //   获取下拉框数据
    async getUser() {
      const { data } = await this.$Ajax.get(
        `/api/services/app/CustomerQuotationApiService/GettQuotationMgrInitData?customerId=${this.customerId}`
      )
      this.contactsData = data.result.contactsData
      this.quotationTtemplateData = data.result.quotationTtemplateData
      this.quotationTypeData = data.result.quotationTypeData
      this.spinShow = false
    },
    async getDetail() {
      const { data } = await this.$Ajax.get(
        `/api/services/app/CustomerQuotationApiService/GetDetailById?id=${this.quotationId}`
      )

      this.form = data.result
      this.spinShow = false
    },
    handlePreview(e) {
      console.log('🚀 ~ handlePreview ~ e:', e)
      if (e.url) {
        window.open(e.url)
      } else {
        window.open(this.$constDefinition.baseUrl + e.response.result.url)
      }
      // e.url
    },
    handleDownload(id, name, type) {
      let fileExtension,
        fileParts = null
      if (name.indexOf('.') > -1) {
        fileParts = name.split('.')
        fileExtension = '.' + fileParts[fileParts.length - 1]
      }
      this.$downLoad(`/files/downloadFile_Path/${id}`, type, fileExtension)
    },
    //文件上传成功
    handleSuccess(e) {
      if (!Array.isArray(this.form.模板_Files)) {
        this.form.模板_Files = []
      }
      this.form.模板_Files = [e.result]
      this.$refs.form.validateField('模板_Files')
      // this.$refs.upload.clearFiles()
    },
    //文件格式错误
    handleFormatError(file) {
      this.$Notice.warning({
        title: '文件格式错误',
        // desc: 'File format of ' + file.name + ' is incorrect, please select jpg or png.'
      })
    },
    //移除文件
    async handleRemove(e) {
      console.log('🚀 ~ handleRemove ~ e:', e)
      try {
        const { data } = await this.$Ajax.delete(
          `/api/services/app/ComFile/DeleteFileByGuid?guid=${this.form.templateGuid}`
        )
        this.form.模板_Files = []
      } catch (error) {
        this.$Message.error({
          content: '删除失败',
        })
      }
    },
	
	
	//文件上传成功
	handleSuccessTBLC(e) {
	  if (!Array.isArray(this.form.投标流程_Files)) {
	    this.form.投标流程_Files = []
	  }
	  this.form.投标流程_Files = [e.result]
	  this.$refs.form.validateField('投标流程_Files')
	  // this.$refs.upload.clearFiles()
	},
	//文件格式错误
	handleFormatErrorTBLC(file) {
	  this.$Notice.warning({
	    title: '文件格式错误',
	    // desc: 'File format of ' + file.name + ' is incorrect, please select jpg or png.'
	  })
	},
	//移除文件
	async handleRemoveTBLC(e) {
	  console.log('🚀 ~ handleRemove ~ e:', e)
	  try {
	    const { data } = await this.$Ajax.delete(
	      `/api/services/app/ComFile/DeleteFileByGuid?guid=${this.form.templateGuid}`
	    )
	    this.form.投标流程_Files = []
	  } catch (error) {
	    this.$Message.error({
	      content: '删除失败',
	    })
	  }
	},
	
	//文件上传成功
	handleSuccessBSFW(e) {
	  if (!Array.isArray(this.form.标书范文_Files)) {
	    this.form.标书范文_Files = []
	  }
	  this.form.标书范文_Files = [e.result]
	  this.$refs.form.validateField('标书范文_Files')
	  // this.$refs.upload.clearFiles()
	},
	//文件格式错误
	handleFormatErrorBSFW(file) {
	  this.$Notice.warning({
	    title: '文件格式错误',
	    // desc: 'File format of ' + file.name + ' is incorrect, please select jpg or png.'
	  })
	},
	//移除文件
	async handleRemoveBSFW(e) {
	  console.log('🚀 ~ handleRemove ~ e:', e)
	  try {
	    const { data } = await this.$Ajax.delete(
	      `/api/services/app/ComFile/DeleteFileByGuid?guid=${this.form.templateGuid}`
	    )
	    this.form.标书范文_Files = []
	  } catch (error) {
	    this.$Message.error({
	      content: '删除失败',
	    })
	  }
	},
  },
}
</script>
<style lang="less" scoped>
.fileList {
  display: flex;
  flex-wrap: wrap;
  .filename {
    width: 80px;
    word-break: break-all;
    text-overflow: -o-ellipsis-lastline;
    overflow: hidden; //溢出内容隐藏
    text-overflow: ellipsis; //文本溢出部分用省略号表示
    display: -webkit-box; //特别显示模式
    -webkit-line-clamp: 2; //行数
    line-clamp: 2;
    -webkit-box-orient: vertical; //盒子中内容竖直排列
  }
}
.img {
  margin-right: 10px;
}
.pos {
  position: relative;
}
.pos:hover .img_magnify {
  display: inline-block;
}
.ico {
  position: relative;
  top: 50%;
  left: 50%;
  transform: translate(-100%, -50%);
  cursor: pointer;
}
.img_magnify {
  display: none;
  background: rgba(0, 0, 0, 0.459);
  position: absolute;
  z-index: 1;
  width: 85px;
  height: 85px;
  left: 0px;
  right: 0;
  top: 0;
  bottom: 0;
}
.img_wrap {
  display: flex;
  flex-direction: column;
  padding: 0px 0px;
}
/deep/.ivu-input[type='radio'] {
  width: 20px !important;
}
</style>